import React from 'react';
import { useNavigate } from 'react-router-dom';
import DynamicBackground from '../../components/DynamicBackground';
import CreditsDisplay from '../../components/CreditsDisplay';
import { useUser } from '../../contexts/UserContext';
import '../../styles/darkMode.css';
import './ToolsLanding.css';

interface Tool {
  title: string;
  description: string;
  category: string;
  path: string;
}

const ToolsLanding: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useUser();

  const tools: Tool[] = [
    {
      title: 'Contract Analyzer',
      description: 'Upload and analyze your music contracts',
      category: 'Analysis',
      path: '/interpreter'
    },
    {
      title: 'Analysis History',
      description: 'View your past contract analyses and results',
      category: 'History',
      path: '/dashboard'
    },
    {
      title: 'Contract Generator',
      description: 'Generate various types of music industry contracts',
      category: 'Generator',
      path: '/contract-generator'
    },
    {
      title: 'Contract History',
      description: 'View your past contract generations and agreements',
      category: 'History',
      path: '/contract-generations'
    },
    {
      title: 'Music Law Dictionary',
      description: 'Search and learn about music law terms and definitions',
      category: 'Reference',
      path: '/dictionary'
    },
  ];

  return (
    <DynamicBackground>
      <div className="dark-container">
        <div className="user-header">
          {user?.picture && (
            <img 
              src={user.picture} 
              alt={`${user.name}'s profile`} 
              className="user-profile-picture"
            />
          )}
          <CreditsDisplay variant="header" />
          <div className="user-welcome">
            <h1 className="dark-title">
              Welcome, {user?.name || 'User'}!
            </h1>
            <p className="dark-subtitle">How can we help you today?</p>
          </div>
        </div>
        
        <div className="tools-landing-grid">
          {tools.map((tool, index) => (
            <div 
              key={index} 
              className="dark-card tool-landing-card"
              onClick={() => navigate(tool.path)}
            >
              <h3 className="dark-text">{tool.title}</h3>
              <p className="dark-text-muted category">{tool.category}</p>
              <p className="dark-text description">{tool.description}</p>
            </div>
          ))}
        </div>
      </div>
    </DynamicBackground>
  );
};

export default ToolsLanding;